'use strict';

var copy = require('shallow-copy');

var getCurrentSortMode = function getCurrentSortMode(hasKeywords, requestedSortMode) {
  if (requestedSortMode === 'ListedDate') {
    return 'ListedDate';
  }
  return hasKeywords ? 'KeywordRelevance' : 'ListedDate';
};

var refine = function refine(sortModes, params) {
  var hasKeywords = typeof params.keywords === 'string' && params.keywords.trim() !== '';
  var currentSortMode = getCurrentSortMode(hasKeywords, params.sortmode);

  return {
    sortmode: sortModes.filter(function (sortMode) {
      return sortMode.value !== 'KeywordRelevance' || hasKeywords;
    }).map(function (sortMode) {
      var newSortMode = copy(sortMode);

      newSortMode.isActive = currentSortMode === newSortMode.value;

      if (!newSortMode.isActive) {
        newSortMode.refineParams = copy(params);
        newSortMode.refineParams.sortmode = newSortMode.value;
      }

      return newSortMode;
    })
  };
};

module.exports = refine;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-refine-job-search/dist/refinements/sortmode.js
 ** module id = 500
 ** module chunks = 0
 **/